import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  listItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '0',
  },
  listItemClosedDrawer: {
    padding: '6px',
  },
  listItemText: {
    color: theme.palette.primary.sideBarTextColor,
    '& .MuiTypography-root': {
      fontWeight: 500,
      fontSize: '14px',
    },
  },
  listItemIcon: {
    minWidth: '40px',
    transition: 'min-width 0.1s',
    opacity: '0.8',
    fill: theme.palette.primary.sideBarIconColor,
    color: theme.palette.primary.sideBarIconColor,
    '& > svg': {
      fill: theme.palette.primary.sideBarIconColor,
      color: theme.palette.primary.sideBarIconColor,
      '& > g': {
        fill: theme.palette.primary.sideBarIconColor,
        color: theme.palette.primary.sideBarIconColor,
        '& > path': {
          fill: theme.palette.primary.sideBarIconColor,
          color: theme.palette.primary.sideBarIconColor,
        },
      },
      '& > path': {
        fill: theme.palette.primary.sideBarIconColor,
        color: theme.palette.primary.sideBarIconColor,
      },
    },
  },
  listItemIconClosedDrawer: {
    minWidth: '56px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    transition: 'min-width 100s',
    opacity: '0.8',
    '& > svg': {
      '& > g': {
        '& > path': {
          fill: theme.palette.primary.sideBarIconColor,
        },
      },
      '& > path': {
        fill: theme.palette.primary.sideBarIconColor,
      },
    },
  },
  hideOpacity: {
    opacity: 1,
  },
  linkActive: {
    color: theme.palette.primary.main,
  },
  iconActive: {
    color: theme.palette.primary.main,
    '& > svg': {
      '& > g': {
        '& > path': {
          fill: theme.palette.primary.main,
        },
      },
      '& > path': {
        fill: theme.palette.primary.main,
      },
    },
  },
  listItemsContainer: {
    borderTop: 'none',
  },
  hideContent: {
    display: 'none',
  },
  lastElement: {
    borderBottom: 'none',
  },
  listItemIconShow: {
    '& > span': {
      display: 'none',
    },
    '&:hover': {
      '& > span': {
        display: 'flex',
        justifyContent: 'flex-end',
      },
    },
  },
  listItemBold: {
    '& .MuiListItemText-primary': {
      fontWeight: '600',
    },
  },
  listItemContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  listItemSubMenu: {
    '& > div:first-of-type': {
      paddingTop: 0.75,
    },
  },
  listItemButton: {
    padding: '6px 10px',
    borderRadius: '12px',
    alignItems: 'center',
  },
  listItemButtonActive: {
    backgroundColor: theme.palette.primary.lightBlue,
    '&:hover': {
      backgroundColor: theme.palette.primary.lightBlue,
    },
  },
  listItemActiveIndicator: {
    position: 'absolute',
    left: 0,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 3,
    height: '1.25rem',
    backgroundColor: theme.palette.primary.main,
    zIndex: 10,
    borderTopRightRadius: '9999px',
    borderBottomRightRadius: '9999px',
  },
  listItemButtonNoHover: {
    '&:hover': {
      backgroundColor: 'unset',
    },
  },
  subMenuItem: {
    fontSize: 12,
    fontWeight: 700,
    marginTop: 1.75,
    paddingBottom: 0,
    textTransform: 'uppercase',
    opacity: '0.55',
  },
  featuredIcon: {
    marginLeft: 0.75,
    fontSize: 18,
    color: '#c89a3d',
  },
};
